import { render, staticRenderFns } from "./MarkerSehenswuerdigkeitContent.vue?vue&type=template&id=8f5c59b8&scoped=true"
import script from "./MarkerSehenswuerdigkeitContent.vue?vue&type=script&lang=js"
export * from "./MarkerSehenswuerdigkeitContent.vue?vue&type=script&lang=js"
import style0 from "./MarkerSehenswuerdigkeitContent.vue?vue&type=style&index=0&id=8f5c59b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5c59b8",
  null
  
)

export default component.exports